






































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CommonDialog from '../organisms/CommonDialog.vue';
import { dayjs, D_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { SupportPlanService } from '../../biz/remote/SupportPlanService';
import { MessageDialog } from '../../utils/MessageDialog';
import { SupportPlanDTO } from '../../../src_server/entity/dto/SupportPlanDTO';
import { SupportPlanConst } from '../../../src_server/entity/master/SupportPlanConst';
import { basicStrengthTitle, getItemOptions } from '../../../src_server/entity/master/basicStrengthData';
import { PlanConcreteTargets } from '../../../src_server/entity/generated/PlanConcreteTargets';
import { Session } from '../../utils/Session';
import { getBuildingName } from '../../../src_server/entity/master/buildingData';
import { routeHelperOpenNewTab } from '../../utils/routeHelper';

@Component({
  components: { CommonDialog },
  filters: {
    dateFormat: (dt: Date) => {
      return dayjs(dt).format(D_FORMAT_JA);
    },
  },
})
export default class SupportPlanDialog extends Vue {
  dto: SupportPlanDTO = new SupportPlanDTO();
  unwatchStartDt!: any;

  get serviceTypeOption() {
    return [
      { value: '児童発達', title: '児童発達' },
      { value: '放課後等デイサービス', title: '放課後等デイサービス' },
    ];
  }

  get buildingName() {
    return getBuildingName(Session.getSessionBuildingId());
  }

  get longTerm() {
    if (!this.dto.plan_targets) return null;
    return this.dto.plan_targets.filter((p) => p.term_type === SupportPlanConst.LONG_TERM);
  }
  get shortTerm() {
    if (!this.dto.plan_targets) return null;
    return this.dto.plan_targets.filter((p) => p.term_type === SupportPlanConst.SHORT_TERM);
  }
  get concreteTarget() {
    return this.dto.plan_concrete_targets;
  }

  get itemNameOptions() {
    return Object.keys(basicStrengthTitle).map((key) => {
      return { title: basicStrengthTitle[key], value: basicStrengthTitle[key] };
    });
  }

  levelOptions(item: string) {
    const foundKey = Object.keys(basicStrengthTitle).find((key) => basicStrengthTitle[key] === item);
    if (foundKey) {
      return getItemOptions(foundKey);
    }
    return [];
  }

  @Watch('dto.support_plan.start_dt')
  setEnd() {
    const start = dayjs(this.dto.support_plan.start_dt);
    this.dto.support_plan.end_dt = start.add(5, 'month').endOf('month').toDate();
  }

  public show(dto: SupportPlanDTO) {
    this.dto = dto;
    this.unwatchStartDt = this.$watch('dto.support_plan.start_dt', () => {
      MessageDialog.alert(`開始日を修正したため、有効期限を6ヶ月後に変更しました`).then();
    });

    if (!this.dto.support_plan.service_type) {
      this.dto.support_plan.service_type = '放課後等デイサービス';
    }
    if (!this.dto.support_plan.create_dt) {
      this.dto.support_plan.create_dt = new Date();
    }
    if (!this.dto.support_plan.start_dt) {
      this.dto.support_plan.start_dt = new Date();
    }
    if (!this.dto.support_plan.end_dt) {
      this.dto.support_plan.end_dt = new Date();
    }

    console.log(dto);
    (this.$refs['SupportPlanDialog'] as CommonDialog).show();
  }
  clear(concreat_target: PlanConcreteTargets) {
    concreat_target.target_item = '';
    concreat_target.concrete_target = '';
    concreat_target.support_contents = '';
  }

  async print(support_plan_id: number) {
    const isOK = await MessageDialog.confirm(`個別支援計画を更新して印刷ページを開きます。よろしいですか？`);
    if (isOK) {
      const biz = new SupportPlanService();
      await biz.updatePlan(this.dto);
      this.$emit('changed', this.dto);
      routeHelperOpenNewTab(this, 'SupportPlanPrintPage', { support_plan_id: support_plan_id });
    }
  }

  public close() {
    (this.$refs['SupportPlanDialog'] as CommonDialog).hide();
    this.unwatchStartDt(); // 日付のヲッチを一回削除
  }

  private async commit() {
    const isOK = await MessageDialog.confirm(`個別支援計画を更新します。よろしいですか？`);
    if (isOK) {
      const biz = new SupportPlanService();
      await biz.updatePlan(this.dto);
      this.$emit('changed', this.dto);
      this.close();
    }
  }
}
